import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Typography,
  TextField,
  FormControl,
  Radio,
  TextareaAutosize,
  OutlinedInput,
  Icon,
  Chip,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
} from "@mui/material";
import dayjs from 'dayjs'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import WarningDialog from "../../../components/WarningConfirm";
import { useTranslation } from "react-i18next";
import { getGoalType, getDropdownMetric, getDropdownUnit, getGroupCategory, getCategoryWeight, getEvaluatorList, getMemberList, getMemberTeamList, postCreateMyGoal, getScaleLevel, getAlignmentList, getMyGoalEditDetail } from "../../../actions/mygoal";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../icons/arrow-left.svg";
import { ReactComponent as CloseButtonIcon } from "../../../icons/close-green.svg";
import { makeStyles } from "@mui/styles";
import { ReactComponent as LinkActive } from "../../../icons/link-goal-active.svg";
import { ReactComponent as LinkInactive } from "../../../icons/link-goal-inactive.svg";
import { ReactComponent as CasActive } from "../../../icons/cas-active.svg";
import { ReactComponent as CasInactive } from "../../../icons/cas-inactive.svg";
import { ReactComponent as InNoneAlign } from "../../../icons/innone-align.svg";
import { ReactComponent as NoneAlign } from "../../../icons/none-align.svg";

// import axios from "axios";
const MyGoalEditForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _ = require("lodash");
  const navigate = useNavigate();
  const { state } = useLocation();
  const { serial } = useParams();
  const goalDetailRef = useRef(null)
  const goalMemberRef = useRef(null)
  const goalWeightRef = useRef(null)
  const goalTypeRef = useRef(null)
  const goalScaleRef = useRef(null)

  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
    memberSearch: {
      maxHeight: '300px',
      padding: '37px',
      width: "99%",
      minHeight: "50px",
      background: "#FFF",
      zIndex: "10",
      webkitBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      mozBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      boxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      overflow: 'hidden',
    },
    alignmentSearch: {
      maxHeight: '300px',
      padding: '37px',
      width: "99%",
      minHeight: "50px",
      background: "#FFF",
      zIndex: "10",
      webkitBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      mozBoxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      boxShadow: "3px 4px 6px 2px rgb(0 0 0 / 30%)",
      overflow: 'hidden',
      marginLeft: '15px',
    }
  };

  const useStyles = makeStyles({
    closeSvg: {
      "& > path": {
        fill: "#5DA196"
      },
      '& g > path': {
        fill: '#5DA196'
      },
    },
  })

  const classes = useStyles();

  // Function Start

  // Common Start
  const goto = (route, data) => {
    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }

  const isEmpty = (data) => {
    if (data == null || data == "" || data.length == 0) {
      return true
    } else
      return false
  }

  const confirmPage = () => {
    var data = {
      goal_detail: {
        goal_name: goalName,
        goal_details: goalDetail,
        start_date: startDate,
        end_date: endDate,
        goal_metric: goalMetric,
        target_condition: condition,
        unit: unit,
        specify_unit: others,
        target_value: targetValue,
      },
      goal_category: {
        goal_category_id: goalCategory,
        evaluation_weight: weight,
      },
      scale_level: scaleLevel,
      goal_type: goalType,
      suggestion_type: null,
      goal_template_id: null,
      goal_member_id: null,
      goal_member: memberList.map((item) => item.code),
      // {
      //   team: memberType,
      //   include: member,
      //   exclude_member: null
      // },
      evaluator_permission: {
        evaluator: evaluator?.code,
        permission: permission,
      },
    }
    // dispatch(postCreateMyGoal(data))
    //   .then(resp => {
    //     if(resp.success) {
    //       goto('/mygoal-create-success')
    //     }
    //   })
  }

  const chooseLibrary = (val) => {
    setCancascading(val?.options?.cascading)
    setGoalType(val?.code)
  }

  const chooseCategory = (id) => {
    setCategory(id)
    dispatch(getCategoryWeight(id))
      .then(resp => {
        if (resp.data.goalCategoryWeight.weight) {

          let w = 100 - resp.data.goalCategoryWeight.weight
          w = Math.round(w * 100) / 100
          setCategoryWeight(w);

        } else {
          setCategoryWeight(100)
        }
      })
  }
  // Common End

  // Varify & Set Data Start
  const numberNotOverlap = (scaleLevelList) => {
    var overlap = false;
    var orderScaleLevel = 'asc';
    scaleLevelList.map((scaleLevel, idx) => {
      if (scaleLevel.min_value == null || scaleLevel.max_value == null) {
        overlap = true;
      } else {
        if (idx == 0) {
          if (parseInt(scaleLevel.max_value) - parseInt(scaleLevel.min_value) > 0) {
            orderScaleLevel = 'asc';
            setOrderScale('asc')
          } else {
            orderScaleLevel = 'desc';
            setOrderScale('desc')
          }
        } else {
          if (orderScaleLevel == 'asc') {
            if (parseInt(scaleLevel.max_value) - parseInt(scaleLevel.min_value) < 0) {
              overlap = true;
            }
          } else {
            if (parseInt(scaleLevel.min_value) - parseInt(scaleLevel.max_value) < 0) {
              overlap = true;
            }
          }
        }
      }
    })
    if (orderScaleLevel = 'asc') {
      if (parseInt(scaleLevelList[1]?.min_value) - parseInt(scaleLevelList[0]?.max_value) <= 0 || parseInt(scaleLevelList[2]?.min_value) - parseInt(scaleLevelList[1]?.max_value) <= 0 ||
        parseInt(scaleLevelList[3]?.min_value) - parseInt(scaleLevelList[2]?.max_value) <= 0 || parseInt(scaleLevelList[4]?.min_value) - parseInt(scaleLevelList[3]?.max_value) <= 0
      ) {
        overlap = true;
      }
    } else {
      if (parseInt(scaleLevelList[1]?.min_value) - parseInt(scaleLevelList[0]?.max_value) > 0 || parseInt(scaleLevelList[2]?.min_value) - parseInt(scaleLevelList[1]?.max_value) > 0 ||
        parseInt(scaleLevelList[3]?.min_value) - parseInt(scaleLevelList[2]?.max_value) > 0 || parseInt(scaleLevelList[4]?.min_value) - parseInt(scaleLevelList[3]?.max_value) > 0
      ) {
        overlap = true;
      }
    }
    return overlap;
  }

  const checkField = () => {
    var data = {}
    if (isEmpty(goalType)) {
      data = Object.assign(data, { goalType: true })
    }
    if (isEmpty(goalName)) {
      data = Object.assign(data, { name: true })
    }
    if (isEmpty(goalDetail)) {
      data = Object.assign(data, { detail: true })
    }
    if (isEmpty(startDate)) {
      data = Object.assign(data, { startDate: true })
    }
    if (isEmpty(endDate)) {
      data = Object.assign(data, { endDate: true })
    }
    if (isEmpty(goalMetric)) {
      data = Object.assign(data, { goalMetric: true })
    }
    if (goalMetric === 'value') {
      if (isEmpty(condition)) {
        data = Object.assign(data, { condition: true })
      }
      if (isEmpty(unit)) {
        data = Object.assign(data, { unit: true })
      }
      if (isEmpty(targetValue)) {
        data = Object.assign(data, { targetValue: true })
      } else {
        const unitOption = selectOption['unitOption'].filter((item) => { if (item.code == unit.toLowerCase()) return item })[0]
        const min = unitOption.options.min_value;
        const max = unitOption.options.max_value;
        if (max) {
          if (targetValue < min || targetValue > max) {
            data = Object.assign(data, { targetValue: true })
          }
        } else {
          if (targetValue < min) {
            data = Object.assign(data, { targetValue: true })
          }
        }
      }
    }
    if (goalType == 1 || goalType == 2) {
      if (isEmpty(member)) {
        data = Object.assign(data, { member: true })
      }
      if (isEmpty(memberType)) {
        data = Object.assign(data, { memberType: true })
      }
    }
    if (isEmpty(weight)) {
      data = Object.assign(data, { weight: true })
    }
    if (goalMetric === 'date') {
    } else if (goalMetric === 'value') {
      if (numberNotOverlap(scaleLevel)) {
        data = Object.assign(data, { scaleLevel: true })
      }
    }

    if (Object.keys(data).length != 0 && data.goalType) {
      goalTypeRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0
      && (data.name || data.detail || data.startDate || data.endDate || data.goalMetric || data.condition || data.unit || data.targetValue)) {
      goalDetailRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && data.scaleLevel) {
      goalScaleRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && (data.member || data.memberType) && (goalType == 1 || goalType == 2)) {
      goalMemberRef.current.scrollIntoView({ behavior: 'smooth' })
    } else if (Object.keys(data).length != 0 && data.weight) {
      goalWeightRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    if (Object.keys(data).length == 0) {
      confirmPage()
    }

    setVerifyField(data)
  }

  const handleChange = (value, type) => {
    var stateOption = { ...selectOption };
    if (type == 'evaluator') {
      setEvaluator(value.code)
    } else if (type == 'metric') {
      setGoalMetric(value)
      if (value == 'Value') {
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '40' },
          { min_value: '41', max_value: '60' },
          { min_value: '61', max_value: '80' },
          { min_value: '81', max_value: '100' },
        ])
        if (respOption) {
          respOption.map((data) => {
            if (data.code == value.toLowerCase() && data.options != null) {
              var stateOptions = { ...selectOption }
              stateOptions['condition'] = data.options.target_condition.map((option) => option.label);
              setSelectOption(stateOptions)
            }
          })
        }
      } else if (value == 'Date') {
        setUnit(null)
        setCondition(null)
        setTargetValue(endDate != null ? dayjs(endDate).format('DD/MM/YYYY') : "")
        setScaleCondition([
          { min_value: '01/01/2020', max_value: '31/01/2020' },
          { min_value: '01/02/2020', max_value: '28/02/2020' },
          { min_value: '01/03/2020', max_value: '31/03/2020' },
          { min_value: '01/04/2020', max_value: '30/04/2020' },
          { min_value: '01/05/2020', max_value: '31/05/2020' },
        ])
      } else if (value == 'Accomplishment') {
        setUnit(null)
        setCondition(null)
        setTargetValue('Success')
      }
    } else if (type == 'unit') {
      setUnit(value)
      setScaleCondition([
        { min_value: '1', max_value: '20' },
        { min_value: '21', max_value: '40' },
        { min_value: '41', max_value: '60' },
        { min_value: '61', max_value: '80' },
        { min_value: '81', max_value: '100' },
      ])
      if (value == 'Minute') {
        setScaleCondition([
          { min_value: '1', max_value: '20' },
          { min_value: '21', max_value: '30' },
          { min_value: '31', max_value: '40' },
          { min_value: '41', max_value: '50' },
          { min_value: '51', max_value: '60' },
        ])
      } else if (value == 'Hours') {
        setScaleCondition([
          { min_value: '1', max_value: '4' },
          { min_value: '5', max_value: '8' },
          { min_value: '9', max_value: '12' },
          { min_value: '13', max_value: '16' },
          { min_value: '17', max_value: '24' },
        ])
      } else if (value == 'Score') {
        setScaleCondition([
          { min_value: '1', max_value: '200' },
          { min_value: '201', max_value: '400' },
          { min_value: '401', max_value: '600' },
          { min_value: '601', max_value: '800' },
          { min_value: '801', max_value: '1000' },
        ])
      }
    } else if (type == 'condition') {
      setCondition(value)
    } else if (type == 'memberType') {
      setMemberType(value)
      stateOption['member'] = memberOption
      setSelectOption(stateOption);
    } else if (type == 'member') {
      setMember(value)
    } else if (type == 'permission') {
      setPermission(value)
    } else if (type === 'value') {
      setValue(value)
    } else if (type === 'type') {
      setType(value)
    }
  };

  const changeValue = (value, type) => {
    var scaleLevelData = [...scaleLevel];
    if (type == 'name') {
      setGoalName(value)
    } else if (type == 'detail') {
      setGoalDetail(value)
    } else if (type == 'custom') {
      setOthers(value)
    } else if (type == 'targetValue') {
      setTargetValue(value)
    } else if (type == 'weight') {
      setWeight(value)
    } else if (type == 'scaleMin1') {
      scaleLevelData[0]['min_value'] = value
    } else if (type == 'scaleMax1') {
      if (new Date(value) < new Date(scaleLevelData[0]['min_value'])) {
        setOrderScale('desc');
      } else {
        setOrderScale('asc');
      }
      scaleLevelData[0]['max_value'] = value
    } else if (type == 'scaleMin2') {
      scaleLevelData[1]['min_value'] = value
    } else if (type == 'scaleMax2') {
      scaleLevelData[1]['max_value'] = value
    } else if (type == 'scaleMin3') {
      scaleLevelData[2]['min_value'] = value
    } else if (type == 'scaleMax3') {
      scaleLevelData[2]['max_value'] = value
    } else if (type == 'scaleMin4') {
      scaleLevelData[3]['min_value'] = value
    } else if (type == 'scaleMax4') {
      scaleLevelData[3]['max_value'] = value
    } else if (type == 'scaleMin5') {
      scaleLevelData[4]['min_value'] = value
    } else if (type == 'scaleMax5') {
      scaleLevelData[4]['max_value'] = value
    }
    setScaleLevel(scaleLevelData)
  }

  const valueCondition = () => {
    let text = ''
    if (unit == 'Percentage') {
      text = "0.00 - 100.00"
    } else if (unit == 'Minute') {
      text = "0.00 - 100.00"
    } else if (unit == 'Hour') {
      text = "0.00 - 100.00"
    } else if (unit == 'Day') {
      text = "0.00 - 100.00"
    } else if (unit == 'Score') {
      text = "0 - 1,000.00"
    } else if (unit == 'Client') {
      text = "0 - 100,000.00"
    } else if (unit == 'Count') {
      text = "0 - 100,000.00"
    } else if (unit == 'THB') {
      text = "0 - 1,000,000,000.00"
    } else if (unit == 'USD') {
      text = "0 - 1,000,000,000.00"
    } else if (unit == 'Others') {
      text = "0 - 1,000,000,000.00"
    }
    return <Typography style={{ fontSize: 14, color: '#A3A3A3' }}>{text}</Typography>
  }

  const addDate = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const setValueFromAnotherPage = () => {
    if (state) {
      setGoalName(state.name ?? state.goalName);
      setGoalDetail(state.description);
      if (state.metric) {
        handleChange(state.metric.description.toLowerCase(), 'metric');
      }
      if (state?.serialEvaluation) setEvaluatorSerial(state.serialEvaluation)
      setCondition(state.condition);
      setCategory(state.goalCategory);
      if (state.start_date) setStartDate(convertDateToCalendar(state.start_date));
      if (state.end_date) setEndDate(convertDateToCalendar(state.end_date));
      setGoalType(state.type.code);
      if (state?.member) setMember(state.member);
      setMemberType(state.memberType);
      setOthers(state.others);
      setPermission(state.permission);
      setTargetValue(state.target_value);
      setUnit(state.unit.description);
      if (state.weight) setWeight(state.weight);
      if (state.metric) setGoalMetric(state.metric.description.toLowerCase());
      if (state.categoryWeight) setCategoryWeight(state.categoryWeight)
      setSelectOption(state.selectOption)
      setGoalCategoryOptions(state.goalCategoryOptions)
      setMemberTeamOption(state.memberTeamOption)
      setMemberOption(state.memberOption)
    }
  }

  const convertDateToCalendar = (date) => {
    var dataSplit = date.split('/')
    var dateConvert = new Date(dataSplit[2], dataSplit[1], dataSplit[0])
    return dateConvert
  }

  const changeAlignment = (val) => {
    if (val != goalAlignment) {
      var stateOption = { ...selectOption };
      setType([])
      setValue([])
      if (val == 1) {
        stateOption['type'] = ['Associated Goal', 'Parent Goal'];
        stateOption['value'] = alignmentOption;
      } else {
        stateOption['type'] = ['Member', 'Team'];
        stateOption['value'] = [];
      }
      setSelectOption(stateOption)
    }
    setGoalAlingment(val)
  }

  const requireField = (text) => {
    return (
      <Grid container direction="row">
        <Grid>
          <Typography>{text}</Typography>
        </Grid>
        <Grid>
          <Typography style={{ color: 'red' }}>&nbsp;*</Typography>
        </Grid>
      </Grid>)
  }

  const handleConfirmApprove = (val) => {
    openApproveDialog(false);
    goto('/mygoal')
  }

  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }
  // Varify & Set Data End

  const searchMember = (value) => {
    setTeamSearch(value);
    if (value.length >= 3) {
      setIsSearchMember(true);
    } else {
      setIsSearchMember(false);
    }
  }

  const searchAlignment = (value) => {
    setAlignmentSearch(value);
    if (value.length >= 3) {
      setIsSearchAlignment(true);
    } else {
      setIsSearchAlignment(false);
    }
  }

  const manageMemberList = (member) => {
    var lists = [...memberList]
    if (lists.findIndex((idx) => idx.code == member.code) >= 0) {
      const index = lists.findIndex((idx) => idx.code == member.code);
      lists.splice(index, 1)
    } else {
      lists.push(member)
    }
    setMemberList(lists)
  }
  const manageAlignemntList = (member) => {
    var lists = [...memberList]
    if (lists.findIndex((idx) => idx.code == member.code) >= 0) {
      const index = lists.findIndex((idx) => idx.code == member.code);
      lists.splice(index, 1)
    } else {
      lists.push(member)
    }
    setMemberList(lists)
  }

  const removeMember = (index) => {
    var lists = [...memberList]
    lists.splice(index, 1)
    setMemberList(lists)
  }

  const removeAllSelect = () => {
    setMemberList([])
  }

  const checkAllMember = () => {
    var lists = []
    if (memberOption.length !== memberList.length) {
      memberOption.map((item) => {
        if (item?.code.indexOf(teamSearch) >= 0 ||
          item?.firstName.indexOf(teamSearch) >= 0 ||
          item?.lastName.indexOf(teamSearch) >= 0 ||
          item?.empSubName.indexOf(teamSearch) >= 0 ||
          item?.empName.indexOf(teamSearch) >= 0) {
          lists.push(item.code)
        }
      })
    }
    setMemberList(lists)
  }
  const checkAllAlignment = () => {
    var lists = []
    if (memberOption.length !== memberList.length) {
      memberOption.map((item) => {
        if (item?.code.indexOf(teamSearch) >= 0 ||
          item?.firstName.indexOf(teamSearch) >= 0 ||
          item?.lastName.indexOf(teamSearch) >= 0 ||
          item?.empSubName.indexOf(teamSearch) >= 0 ||
          item?.empName.indexOf(teamSearch) >= 0) {
          lists.push(item.code)
        }
      })
    }
    setMemberList(lists)
  }

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  // Function End

  // Variable Start
  const [verifyField, setVerifyField] = React.useState({})
  const [goalType, setGoalType] = React.useState(null)
  const [goalCategory, setCategory] = React.useState(null)
  const [goalName, setGoalName] = React.useState(null)
  const [goalDetail, setGoalDetail] = React.useState(null)
  const [startDate, setStartDate] = React.useState(null)
  const [endDate, setEndDate] = React.useState(null)
  const [targetValue, setTargetValue] = React.useState(null)
  const [weight, setWeight] = React.useState(0)
  const [others, setOthers] = React.useState(null)
  const [evaluator, setEvaluator] = React.useState(null)
  const [goalMetric, setGoalMetric] = React.useState(null)
  const [unit, setUnit] = React.useState(null)
  const [condition, setCondition] = React.useState(null)
  const [memberType, setMemberType] = React.useState(null)
  const [member, setMember] = React.useState([])
  const [permission, setPermission] = React.useState(null)
  const [scaleLevel, setScaleLevel] = React.useState([
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
    { min_value: null, max_value: null },
  ])
  const [categoryWeight, setCategoryWeight] = React.useState(0)
  const [canCascading, setCancascading] = React.useState(false)
  const [scaleCondition, setScaleCondition] = React.useState([
    { min_value: '1', max_value: '20' },
    { min_value: '21', max_value: '40' },
    { min_value: '41', max_value: '60' },
    { min_value: '61', max_value: '80' },
    { min_value: '81', max_value: '100' },
  ])
  const [selectOption, setSelectOption] = React.useState({
    goalMetric: [],
    goalType: [],
    condition: [],
    unit: [],
    evaluator: [],
    member: [],
    memberType: [],
    permission: [],
  })
  const [respOption, setRespOption] = React.useState(null)
  const [goalCategoryOptions, setGoalCategoryOptions] = React.useState([])
  const [memberTeamOption, setMemberTeamOption] = React.useState([])
  const [memberOption, setMemberOption] = React.useState([])
  const [orderScale, setOrderScale] = React.useState('asc');
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false);
  const [evaluatorSerial, setEvaluatorSerial] = React.useState(null);
  const [isSearchMember, setIsSearchMember] = React.useState(false);
  const [isSearchAlignment, setIsSearchAlignment] = React.useState(false);
  const [teamSearch, setTeamSearch] = React.useState(null);
  const [alignmentSearch, setAlignmentSearch] = React.useState(null);
  const [goalAlignment, setGoalAlingment] = React.useState(0)
  const [type, setType] = React.useState("")
  const [value, setValue] = React.useState([]);
  const [alignmentOption, setAlignmentOption] = React.useState([])
  const [memberList, setMemberList] = React.useState([])
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState("");
  const headerMember = [
    { field: 'code', headerName: 'Employee Code', width: 50 },
    { field: 'firstName', headerName: 'Name', width: 100 },
    { field: 'empSubName', headerName: 'Position', width: 100 },
    { field: 'empName', headerName: 'Team', width: 100 },
    { field: '', headerName: '', width: 50 },
  ]

  // Variable End

  useEffect(async () => {
    var stateOption = { ...selectOption };
    stateOption['memberType'] = ['Team', 'Member'];
    stateOption['permission'] = ['Private', 'Line', 'Team'];

    await dispatch(getDropdownMetric())
      .then(resp => {
        var metric = resp.data.metric;
        stateOption['goalMetric'] = metric;
        setRespOption(resp.data.metric)
      })

    await dispatch(getDropdownUnit())
      .then(resp => {
        var unit = resp.data.unit.map((item) => { return item.code.charAt(0).toUpperCase() + item.code.slice(1) })
        stateOption['unit'] = unit;
        stateOption['unitOption'] = resp.data.unit;
      })

    await dispatch(getMemberList())
      .then(resp => {
        let memberList = resp.data.goalMemberList.filter(item => { return item.formStatus === 'draft' })
        setMemberOption(memberList);
      })

    await dispatch(getMemberTeamList())
      .then(resp => {
        setMemberTeamOption(resp.data.goalMemberTeamList);
      })

    await dispatch(getEvaluatorList())
      .then(resp => {
        stateOption['evaluator'] = resp.data.goalEvaluatorList;
      })

    await dispatch(getGoalType(state.serialEvaluation))
      .then(resp => {
        stateOption['goalType'] = resp.data.goalTypeList;
      })

    await dispatch(getGroupCategory(state.serialEvaluation))
      .then(resp => {
        setGoalCategoryOptions(resp.data.goalCategory);
      })

    await dispatch(getScaleLevel(state.serialEvaluation))
      .then(resp => {
        var scaleObject = []
        resp.data.goalScaleLevel?.map((item, key) => {
          scaleObject.push({ min_value: null, max_value: null, serial: item.serial })
        })
        if (scaleObject.length > 0) {
          setScaleLevel(scaleObject)
        }
      })

    await dispatch(getAlignmentList())
      .then(resp => {
        setAlignmentOption(resp.data.list_goal)
        stateOption['value'] = resp.data.list_goal

      })

    await dispatch(getMyGoalEditDetail(state.serialEvaluation))
      .then(resp => {
        if (resp.data) {
          var scaleLevel = resp.data.scale_level;
          var alignmentData = resp.data.alignment;

          if (alignmentData.type === 'linking_parent') {
            setGoalAlingment(1)
            setType('Parent Goal')
            stateOption['type'] = ['Associated Goal', 'Parent Goal'];
            setValue(alignmentData.alignmentList)
          } else if (alignmentData.type === 'linking_associate') {
            setGoalAlingment(1)
            setType('Associated Goal')
            stateOption['type'] = ['Associated Goal', 'Parent Goal'];
            setValue(alignmentData.alignmentList)
          } else if (alignmentData.type === 'cascading_team') {
            setGoalAlingment(2)
            stateOption['type'] = ['Member', 'Team'];
          } else if (alignmentData.type === 'cascading_member') {
            setGoalAlingment(2)
            stateOption['type'] = ['Member', 'Team'];
          }

          setEvaluator(resp.data.evaluator_permission);
          if (scaleLevel.length > 0) {
            setScaleLevel(scaleLevel)
          }
        }
      })

    await setSelectOption(stateOption);

  }, []);

  useEffect(() => {
    setValueFromAnotherPage();
  }, [respOption])

  return (
    <>
      <Helmet>
        <title>My Goal Detail | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goto('/kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/mygoal')}>
                {` My Goal`}
              </span> /
              <span style={styles.end} >
                {` Edit Goal Detail`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500">
                {'Edit Goal Detail'}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16}>
                {'Select present goal from the goal library to use in your goal creation.'}
              </Typography>
            </Grid>
          </Grid>
          <Box ref={goalTypeRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30 }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.labelGoalType")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              {selectOption?.goalType?.map((item, idx) => {
                return (
                  item.code == goalType &&
                  <Grid lg={2} xs={12} key={idx} item>
                    <Card style={goalType == item.code ? { border: '1px solid #5DA196', cursor: 'pointer', cursor: 'pointer' } : { border: null }} onClick={() => { chooseLibrary(item) }}>
                      <CardContent>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalType === item.code} size="small" />
                          </Grid>
                          <Grid item lg={12}>
                            <Icon style={{ color: item?.options?.color || '#FFF', fontSize: 40 }}>{item?.options?.icon}</Icon>
                          </Grid>
                          <Grid item lg={12} mt={3}>
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500">
                              {item.description}
                            </Typography>
                          </Grid>
                          <Grid item lg={12} mt={2}>
                            <Typography fontSize={13} variant="label">
                              {item.description}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
          </Box>
          <Box ref={goalDetailRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.labelGoalDetail")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid lg={12} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.goalName"))}
                </Typography>
              </Grid>
              <Grid lg={12} item >
                <TextField error={verifyField.name} onChange={(e) => changeValue(e.target.value, 'name')} id="outlined-basic" placeholder="Fill your goal name" value={goalName} variant="outlined" required fullWidth size="small" />
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.goalDetail"))}
                </Typography>
              </Grid>
              <Grid lg={12} item>
                <TextareaAutosize
                  fullWidth
                  aria-label="minimum height"
                  minRows={4}
                  placeholder="Describe your goal details"
                  style={{ width: '100%', borderColor: verifyField.detail ? '#FF0000' : '#DCDCDC', padding: '10px' }}
                  value={goalDetail}
                  onChange={(e) => changeValue(e.target.value, 'detail')}
                />
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.startDate"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.endDate"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={startDate}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} error={verifyField.startDate} fullWidth size="small" />}
                    label="Select start date"
                    format="dd/MM/yyyy"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid lg={6} xs={12} item>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={endDate}
                    onChange={(newValue) => {
                      if (goalMetric === 'date') {
                        setTargetValue(dayjs(newValue).format('DD/MM/YYYY'))
                      }
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} error={verifyField.endDate} fullWidth size="small" />}
                    label="Select end date"
                    format="dd/MM/yyyy"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.labalGoalMetric"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.targetCondition"))}
                </Typography>
              </Grid>
              <Grid lg={6} item>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.goalMetric}
                    labelId="metric"
                    id="metric"
                    input={<OutlinedInput size="small" />}
                    value={goalMetric}
                    onChange={(val) => { handleChange(val.target.value, 'metric') }}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select how you measure the activity</em>;
                      } else {
                        return selectOption?.goalMetric?.find((option, idx) => option.code === selected).code
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select how you measure the activity</em>
                    </MenuItem>
                    {selectOption?.goalMetric?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.code}>{option.code}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={6} item>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.condition}
                    disabled={goalMetric !== 'value'}
                    labelId="condition"
                    id="condition"
                    value={condition}
                    onChange={(val) => { handleChange(val.target.value, 'condition') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the target condition</em>;
                      } else {
                        return selected
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select the target condition</em>
                    </MenuItem>
                    {selectOption?.condition?.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.unit"))}
                </Typography>
              </Grid>
              <Grid lg={4} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.labelTargetValue"))}
                </Typography>
              </Grid>
              <Grid lg={2} xs={12} item style={{ textAlign: 'right', alignItems: 'flex-end' }}>
                {valueCondition()}
              </Grid>
              <Grid lg={6} item>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    error={verifyField.unit}
                    labelId="unit"
                    id="unit"
                    value={unit}
                    disabled={goalMetric !== 'value'}
                    onChange={(val) => { handleChange(val.target.value, 'unit') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the target unit</em>;
                      } else {
                        return selected
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select the target unit</em>
                    </MenuItem>
                    {selectOption?.unit?.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={6} item>
                <TextField error={verifyField.targetValue} disabled={goalMetric !== 'value'} id="targetValue" placeholder="Fill the target value" variant="outlined" value={targetValue} onChange={(e) => changeValue(e.target.value, 'targetValue')} required fullWidth size="small" style={{ marginLeft: 10, marginTop: 8 }} />
              </Grid>
            </Grid>
            {unit == 'Custom' &&
              <Grid lg={6} container direction="row" style={{ paddingRight: '10px' }}>
                <Grid item lg={2.5} alignSelf="center">
                  <Typography style={{ fontSize: '14px !important' }}>
                    {requireField("Please specify")}
                  </Typography>
                </Grid>
                <Grid item lg={9.5}>
                  <TextField id="others" placeholder="Specify how you measure the activity" variant="outlined" value={others} onChange={(e) => changeValue(e.target.value, 'others')} required fullWidth size="small" style={{ marginLeft: 10, marginTop: 8 }} />
                </Grid>
              </Grid>
            }
          </Box>
          {(goalType == 1 || goalType == 2) &&
            <Box ref={goalMemberRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600}>
                    {t("mygoal.label.goalMember")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid container justifyContent="space-between" direction="row">
                  <Grid item>
                    <Typography fontSize={18} fontWeight={500}>
                      {requireField(t("mygoal.label.goalMember"))}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography fontSize={14} variant="label">
                      Select goal member: {memberList?.length} members
                    </Typography>
                  </Grid>
                </Grid>
                <Grid lg={12} xs={12} item mt={1}>
                  <TextField id="outlined-basic" value={teamSearch} onChange={(e) => searchMember(e.target.value)} placeholder={`Search`} variant="outlined" fullWidth size="small" />
                </Grid>
              </Grid>
              {isSearchMember &&
                <Box style={styles.memberSearch}>
                  <Grid container style={{ alignItems: 'center' }}>
                    <Grid item lg={1}>
                      <Checkbox {...label} mb={2} onClick={() => { checkAllMember() }} />
                    </Grid>
                    <Grid item lg={2}>
                      <Typography variant="label">
                        Employee Code
                      </Typography>
                    </Grid>
                    <Grid item lg={3}>
                      <Typography variant="label">
                        Name
                      </Typography>
                    </Grid>
                    <Grid item lg={3}>
                      <Typography variant="label">
                        Position
                      </Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography variant="label">
                        Team
                      </Typography>
                    </Grid>
                    <Grid item lg={1} style={{ textAlign: 'right' }}>
                      <Typography color='#5DA196' style={{ cursor: 'pointer' }} onClick={() => { setIsSearchMember(false); setTeamSearch('') }}>
                        X
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider pt={'10px'} pb={'20px'} />
                  <Box style={{ maxHeight: '205px', overflowY: 'auto' }}>
                    {memberOption?.map((member, idx) => {
                      return (
                        (member?.code.indexOf(teamSearch) >= 0 ||
                          member?.firstName.indexOf(teamSearch) >= 0 ||
                          member?.lastName.indexOf(teamSearch) >= 0 ||
                          member?.empSubName.indexOf(teamSearch) >= 0 ||
                          member?.empName.indexOf(teamSearch) >= 0
                        ) &&
                        <Grid container key={idx} style={{ alignItems: 'center' }}>
                          <Grid item lg={1}>
                            <Checkbox {...label} checked={memberList.some((list) => list.code === member.code)} onClick={() => { manageMemberList(member) }} />
                          </Grid>
                          <Grid item lg={2}>
                            {member?.code}
                          </Grid>
                          <Grid item lg={3}>
                            {member?.firstName} {member?.lastName}
                          </Grid>
                          <Grid item lg={3}>
                            {member?.empSubName}
                          </Grid>
                          <Grid item lg={2}>
                            {member?.empName}
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Box>
                </Box>
              }
              {(memberList.length > 0 && isSearchMember === false) &&
                <Box style={{ maxHeight: '300px', marginTop: '20px', width: "100%", overflowY: 'scroll', overflowX: 'hidden' }}>
                  <Table aria-label="simple table">
                    <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                      <TableRow>
                        {headerMember?.map((header, idx) => {
                          return (
                            <TableCell align="left" sortDirection="asc" display="flex"
                              className="clickable"
                              key={idx}
                              onClick={() => handleRequestSort(header.field)}>
                              <Typography
                                fontWeight={500}
                                fontSize={16}
                                lineHeight="24px"
                                sx={{ color: "#A0A0A0" }}
                              >
                                {header.headerName}
                                {idx != (headerMember.length - 1)
                                  ?
                                  <TableSortLabel
                                    active={orderBy === header.field}
                                    direction={orderBy === header.field ? order : 'asc'}
                                  />
                                  :
                                  <Typography textAlign="right" style={{ textDecoration: "underline" }} fontSize={14} onClick={() => { removeAllSelect() }}>
                                    Clear All
                                  </Typography>
                                }
                              </Typography>
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {memberList.length > 0 && (
                        stableSort(memberList, getComparator(order, orderBy)).map((row, idx) =>
                          row == null ? (
                            <></>
                          ) : (
                            <TableRow
                              key={row.id}
                              sx={{
                                overflowY: 'auto'
                              }}
                            >
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box
                                  display="flex"
                                  sx={{
                                    flexFlow: "column",
                                    textAlign: "left",
                                    position: "relative",
                                  }}
                                >
                                  <Typography
                                    fontWeight={400}
                                    fontSize={18}
                                    lineHeight="27px"
                                  >
                                    {row.code}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                    >
                                      {row.firstName} {row.lastName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                    >
                                      {row.empSubName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                    >
                                      {row.empName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="right" style={{ borderBottom: 0 }}>
                                <Box display="flex" justifyContent="flex-end">
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                      variant="label"
                                      textAlign="right"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => { removeMember(idx) }}
                                    >
                                      X
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      )}
                    </TableBody>
                  </Table>
                </Box>
              }
            </Box>
          }
          {goalMetric !== null && goalMetric !== 'accomplishment' &&
            <Box ref={goalScaleRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 50 }} mb={3}>
              <Grid container>
                <Grid item mb={2}>
                  <Typography fontSize={22} fontWeight={600}>
                    {t("mygoal.label.scaleLevel")}
                  </Typography>
                  <Typography fontSize={18} fontWeight={500}>
                    {t("mygoal.label.scaleLevelSub")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ border: '1px solid #DADADA', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '13px' }} mt={3}>
                <Grid md={2} item textAlign="center">
                  <Typography variant="label" fontSize={16}>
                    {t("mygoal.label.level")}
                  </Typography>
                </Grid>
                <Grid md={2} item></Grid>
                <Grid md={3} item textAlign="center">
                  <Typography variant="label" fontSize={16}>
                    {t("mygoal.label.actualMin")}
                  </Typography>
                </Grid>
                <Grid md={1} item></Grid>
                <Grid md={3} item textAlign="center">
                  <Typography variant="label" fontSize={16}>
                    {t("mygoal.label.actualMax")}
                  </Typography>
                </Grid>

                {scaleLevel.map((scale, idx) => {
                  return (
                    <Grid container key={idx}>
                      <Grid md={12} item mt={1.5} mb={1.5}>
                        <Divider />
                      </Grid>
                      <Grid md={2} item textAlign="center">
                        <Typography variant="label">
                          {idx + 1}
                        </Typography>
                      </Grid>
                      <Grid md={2} item></Grid>
                      <Grid md={3} item>
                        {goalMetric === 'date'
                          ?
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              value={scale.min_value}
                              onChange={(value) => changeValue(value, `scaleMin${idx + 1}`)}
                              minDate={idx == 0 ? null : orderScale == 'asc' ? addDate(scaleLevel[idx - 1].max_value, 1) : null}
                              maxDate={idx == 0 ? null : orderScale == 'asc' ? scale.max_value == null ? null : scale.max_value : addDate(scaleLevel[idx - 1].max_value, -1)}
                              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                              label="Select min date"
                              format="dd/MM/yyyy"
                              disabled={idx == 0 ? null : scaleLevel[idx - 1].max_value == null}
                            />
                          </LocalizationProvider>
                          :
                          <TextField id="outlined-basic" value={scale.min_value} onChange={(e) => changeValue(e.target.value, `scaleMin${idx + 1}`)} placeholder={`e.g. ${scaleCondition[idx].min_value}`} variant="outlined" required fullWidth size="small" />
                        }
                      </Grid>
                      <Grid md={1} item></Grid>
                      <Grid md={3} item>
                        {goalMetric === 'date'
                          ?
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              value={scale.max_value}
                              minDate={idx == 0 ? null : orderScale == 'asc' ? addDate(scale.min_value, 1) : null}
                              maxDate={idx == 0 ? null : orderScale == 'asc' ? null : addDate(scale.min_value, -1)}
                              onChange={(value) => changeValue(value, `scaleMax${idx + 1}`)}
                              renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                              label="Select max date"
                              format="dd/MM/yyyy"
                              disabled={scale.min_value == null}
                            />
                          </LocalizationProvider>
                          :
                          <TextField id="outlined-basic" value={scale.max_value} onChange={(e) => changeValue(e.target.value, `scaleMax${idx + 1}`)} placeholder={`e.g. ${scaleCondition[idx].max_value}`} variant="outlined" required fullWidth size="small" />
                        }
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
          }
          <Box ref={goalWeightRef} backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 30 }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.goalCategory")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              {goalCategoryOptions?.map((categories, idx) => {
                return (
                  <Grid lg={2} xs={12} key={idx} item>
                    <Card style={goalCategory === categories.id ? { border: '1px solid #5DA196', cursor: 'pointer' } : { border: null, cursor: 'pointer' }} onClick={() => { chooseCategory(categories.id) }}>
                      <CardContent>
                        <Grid item lg={12} xs={12} container textAlign="center">
                          <Grid item>
                            <Radio name="radio" value="1" checked={goalCategory === categories.id} size="small" />
                          </Grid>
                          <Grid item lg={12}>
                            <Icon style={{ color: categories.color, fontSize: 40 }}>{categories.icon}</Icon>
                          </Grid>
                          <Grid item lg={12} mt={3}>
                            <Typography fontSize={18} lineHeight="21px" fontWeight="600">
                              {categories.nameEN}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })}
              <Grid lg={12} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {requireField(t("mygoal.label.evaluatorWeight"))}
                </Typography>
              </Grid>
              <Grid lg={6} xs={12} item>
                <Grid container direction="row">
                  <Grid lg={11}>
                    <TextField error={verifyField.weight} id="weight" placeholder="Fill your evaluation weight" value={weight} onChange={(e) => changeValue(e.target.value, 'weight')} variant="outlined" required fullWidth size="small" style={{ marginLeft: 10, marginTop: 8 }} />
                  </Grid>
                  <Grid ml={2} mt={2}>
                    <Typography fontSize={18} fontWeight={500}>
                      %
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {(!weight) &&
                <Grid lg={6}>
                </Grid>
              }
              {(categoryWeight - weight >= 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#5DA196' }}>{'check_circle'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#5DA196' }}>
                        {t("mygoal.label.evaluatorSub")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {(categoryWeight - weight < 0 && weight > 0) &&
                <Grid lg={6} alignSelf="center" style={{ paddingTop: '20px' }}>
                  <Grid container direction="row">
                    <Grid style={{ paddingRight: '5px' }}>
                      <Icon style={{ color: '#CC6058' }}>{'cancel'}</Icon>
                    </Grid>
                    <Grid lg={11}>
                      <Typography style={{ color: '#CC6058' }}>
                        {`The total score is above the limit by ${weight - categoryWeight} %`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              }
              <Grid lg={4} xs={12} item>
                <Typography fontSize={16} fontWeight={300}>
                  {'The total weights of each goals category is limited to 100% '}
                </Typography>
              </Grid>
              <Grid lg={2} xs={12} item alignItems="flex-end">
                <Grid container direction="row" justifyContent={'flex-end'}>
                  <Typography fontSize={16} fontWeight={300}>
                    {t("mygoal.label.remaining")}
                  </Typography>
                  <Typography ml={1} style={{ color: categoryWeight - weight >= 0 ? '#5DA196' : categoryWeight - weight < 0 ? '#CC6058' : 'black' }}>
                    {`${categoryWeight - weight} % `}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, display: 'none' }} mb={3}>
            <Grid container>
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {t("mygoal.label.evaluatorPermission")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>

              {/* 
              <Grid lg={12} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {t("mygoal.label.alternate")}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item style={{ marginRight: 50 }}>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={evaluator}
                    onChange={(val) => { handleChange(val.target.value, 'evaluator') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the evaluation</em>;
                      } else {
                        var dataFind = selectOption?.evaluator?.find((option, idx) => option.code === selected);
                        if (dataFind === null || dataFind === undefined) {
                          setEvaluator(null)
                          return <em>Select the evaluation</em>;
                        } else {
                          return `${dataFind.firstName} ${dataFind.lastName}`;
                        }
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select the evaluation</em>
                    </MenuItem>
                    {selectOption?.evaluator?.map((option, idx) => {
                      return <MenuItem key={idx} value={option.code}>{`${option.firstName} ${option.lastName}`}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
               */}

              <Grid lg={12} xs={12} item>
                <Typography fontSize={18} fontWeight={500}>
                  {t("mygoal.label.permission")}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item style={{ marginRight: 50 }}>
                <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                  <Select
                    displayEmpty
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={permission}
                    onChange={(val) => { handleChange(val.target.value, 'permission') }}
                    input={<OutlinedInput size="small" />}
                    renderValue={(selected) => {
                      if (selected == null) {
                        return <em>Select the permission</em>;
                      } else {
                        return selected;
                      }
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select the permission</em>
                    </MenuItem>
                    {selectOption?.permission?.map((option, idx) => {
                      return <MenuItem key={idx} value={option}>{option}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          </Box>
          <Box backgroundColor="#FFF" style={{ paddingTop: 30, paddingLeft: 55, paddingBottom: 30, paddingRight: 55 }} mb={3}>
            <Grid direction="row" container>
              <Grid item mb={2}>
                <Typography fontSize={22} fontWeight={600}>
                  {'Goal Alignment'}
                </Typography>
              </Grid>
              <Grid item mt={'8px'} ml={4}>
                <Typography fontSize={14} fontWeight={500} variant="label">
                  {'(Changes in Goal Alignment will affect all related goals and assigned members goal.)'}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid lg={2} xs={12} item>
                <Card style={goalAlignment === 0 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { border: null, cursor: 'pointer' }} onClick={() => { changeAlignment(0) }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container textAlign="center">
                      <Grid item>
                        <Radio name="radio" value="1" checked={goalAlignment === 0} size="small" />
                      </Grid>
                      <Grid item lg={12} mt={3}>
                        {goalAlignment === 0 ? <NoneAlign /> : <InNoneAlign />}
                      </Grid>
                      <Grid item lg={12} mt={6}>
                        <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                          {'None'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={2} xs={12} item>
                <Card style={goalAlignment === 1 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { border: null, cursor: 'pointer' }} onClick={() => { changeAlignment(1) }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container textAlign="center">
                      <Grid item>
                        <Radio name="radio" value="1" checked={goalAlignment === 1} size="small" />
                      </Grid>
                      <Grid item lg={12} mt={3}>
                        {goalAlignment === 1 ? <LinkActive /> : <LinkInactive />}
                      </Grid>
                      <Grid item lg={12} mt={5}>
                        <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                          {'Linking Goal'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid lg={2} xs={12} item>
                <Card style={goalAlignment === 2 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { border: null, cursor: 'pointer' }} onClick={() => { changeAlignment(2) }}>
                  <CardContent>
                    <Grid item lg={12} xs={12} container textAlign="center">
                      <Grid item>
                        <Radio name="radio" value="2" checked={goalAlignment === 2} size="small" />
                      </Grid>
                      <Grid item lg={12}>
                        {goalAlignment == 2 ? <CasActive /> : <CasInactive />}
                      </Grid>
                      <Grid item lg={12} mt={3}>
                        <Typography fontSize={16} lineHeight="21px" fontWeight="600">
                          {'Cascading Goal'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              {goalAlignment != 0 &&
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {goalAlignment == 1 ? requireField('Linking Goal Type') : requireField('Assigned Member')}
                  </Typography>
                </Grid>
              }
              {goalAlignment === 1 &&
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={type}
                      onChange={(val) => { handleChange(val.target.value, 'type') }}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if (selected?.length == 0) {
                          return <em>{goalAlignment === 1 ? 'Select linking goal type' : 'Select assigned type'}</em>;
                        } else {
                          return selected
                        }
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>{goalAlignment === 1 ? 'Select linking goal type' : 'Select assigned type'}</em>
                      </MenuItem>
                      {selectOption?.type?.map((option, idx) => {
                        return <MenuItem key={idx} value={option}>{option}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              }
              {goalAlignment === 1 &&
                <Grid lg={12} xs={12} item>
                  <Typography>
                    {requireField('Linked goal')}
                  </Typography>
                </Grid>
              }
              {goalAlignment === 1 &&
                <Grid lg={12} xs={12} item>
                  <FormControl sx={{ m: 1, minWidth: 80 }} fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={value}
                      multiple
                      onChange={(val) => { handleChange(val.target.value, 'value') }}
                      input={<OutlinedInput size="small" />}
                      renderValue={(selected) => {
                        if (selected?.length == 0) {
                          return <em>{'Select your linked goal'}</em>;
                        } else {
                          return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value, idx) => {
                              var findData = selectOption?.value?.find((data) => data.serial === value)
                              if (findData) {
                                return <Chip key={idx} label={`${findData.name}`}
                                  style={{ borderRadius: '6px', backgroundColor: '#5DA196', color: 'white' }} />
                              } else {
                                return ""
                              }
                            })}
                          </Box>
                        }
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>{'Select your linked goal'}</em>
                      </MenuItem>
                      {(goalAlignment === 1 && permission !== null) &&
                        selectOption?.value?.map((option, idx) => {
                          if (option.options.permission === 'public' || option.options.permission === permission?.toLowerCase()) {
                            return <MenuItem key={idx} value={option.serial}>{option.name}</MenuItem>
                          }
                        })
                      }
                    </Select>
                  </FormControl>
                </Grid>
              }
              {goalAlignment === 1 &&
                <Grid lg={12} xs={12} item>
                  <Typography fontSize={14} variant="label">
                    {`Linked goal: ${value.length} items`}
                  </Typography>
                </Grid>
              }
              {goalAlignment === 2 &&
                <Grid lg={12} xs={12} item>
                  <TextField id="outlined-basic" value={alignmentSearch} onChange={(e) => searchAlignment(e.target.value)} placeholder={`Search`} variant="outlined" fullWidth size="small" />
                </Grid>
              }
              {(goalAlignment === 2 && isSearchAlignment) &&
                <Box style={styles.alignmentSearch}>
                  <Grid container style={{ alignItems: 'center' }}>
                    <Grid item lg={1}>
                      <Checkbox {...label} mb={2} onClick={() => { checkAllAlignment() }} />
                    </Grid>
                    <Grid item lg={2}>
                      <Typography variant="label">
                        Employee Code
                      </Typography>
                    </Grid>
                    <Grid item lg={3}>
                      <Typography variant="label">
                        Name
                      </Typography>
                    </Grid>
                    <Grid item lg={3}>
                      <Typography variant="label">
                        Position
                      </Typography>
                    </Grid>
                    <Grid item lg={2}>
                      <Typography variant="label">
                        Team
                      </Typography>
                    </Grid>
                    <Grid item lg={1} style={{ textAlign: 'right' }}>
                      <Typography color='#5DA196' style={{ cursor: 'pointer' }} onClick={() => { setIsSearchAlignment(false); setAlignmentSearch('') }}>
                        X
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider pt={'10px'} pb={'20px'} />
                  <Box style={{ maxHeight: '205px', overflowY: 'auto' }}>
                    {memberOption?.map((member, idx) => {
                      return (
                        (member?.code.indexOf(alignmentSearch) >= 0 ||
                          member?.firstName.indexOf(alignmentSearch) >= 0 ||
                          member?.lastName.indexOf(alignmentSearch) >= 0 ||
                          member?.empSubName.indexOf(alignmentSearch) >= 0 ||
                          member?.empName.indexOf(alignmentSearch) >= 0
                        ) &&
                        <Grid container key={idx} style={{ alignItems: 'center' }}>
                          <Grid item lg={1}>
                            <Checkbox {...label} checked={memberList.some((list) => list.code === member.code)} onClick={() => { manageAlignemntList(member) }} />
                          </Grid>
                          <Grid item lg={2}>
                            {member?.code}
                          </Grid>
                          <Grid item lg={3}>
                            {member?.firstName} {member?.lastName}
                          </Grid>
                          <Grid item lg={3}>
                            {member?.empSubName}
                          </Grid>
                          <Grid item lg={2}>
                            {member?.empName}
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Box>
                </Box>
              }
              {(goalAlignment === 2 && memberList.length > 0 && isSearchAlignment === false) &&
                <Box style={{ maxHeight: '300px', marginTop: '20px', width: "100%", overflowY: 'scroll', overflowX: 'hidden' }}>
                  <Table aria-label="simple table">
                    <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                      <TableRow>
                        {headerMember?.map((header, idx) => {
                          return (
                            <TableCell align="left" sortDirection="asc" display="flex"
                              className="clickable"
                              key={idx}
                              onClick={() => handleRequestSort(header.field)}>
                              <Typography
                                fontWeight={500}
                                fontSize={16}
                                lineHeight="24px"
                                sx={{ color: "#A0A0A0" }}
                              >
                                {header.headerName}
                                {idx != (headerMember.length - 1)
                                  ?
                                  <TableSortLabel
                                    active={orderBy === header.field}
                                    direction={orderBy === header.field ? order : 'asc'}
                                  />
                                  :
                                  <Typography textAlign="right" style={{ textDecoration: "underline" }} fontSize={14} onClick={() => { removeAllSelect() }}>
                                    Clear All
                                  </Typography>
                                }
                              </Typography>
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {memberList.length > 0 && (
                        stableSort(memberList, getComparator(order, orderBy)).map((row, idx) =>
                          row == null ? (
                            <></>
                          ) : (
                            <TableRow
                              key={row.id}
                              sx={{
                                overflowY: 'auto'
                              }}
                            >
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box
                                  display="flex"
                                  sx={{
                                    flexFlow: "column",
                                    textAlign: "left",
                                    position: "relative",
                                  }}
                                >
                                  <Typography
                                    fontWeight={400}
                                    fontSize={18}
                                    lineHeight="27px"
                                  >
                                    {row.code}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                    >
                                      {row.firstName} {row.lastName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                    >
                                      {row.empSubName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left" style={{ borderBottom: 0 }}>
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                    >
                                      {row.empName}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="right" style={{ borderBottom: 0 }}>
                                <Box display="flex" justifyContent="flex-end">
                                  <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      fontWeight={350}
                                      fontSize={16}
                                      lineHeight="27px"
                                      variant="label"
                                      textAlign="right"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => { removeMember(idx) }}
                                    >
                                      X
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      )}
                    </TableBody>
                  </Table>
                </Box>
              }
            </Grid>
          </Box>
          <Grid container direction="row">
            <Grid container lg={1} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => { openApproveDialog(true) }}>
              <Grid item mt={0.5}>
                <BackIcon />
              </Grid>
              <Grid item ml={1}>
                <Typography>
                  {t('label.back')}
                </Typography>
              </Grid>
            </Grid>
            <Grid lg={10} xs={12} item textAlign="center">
              <Button
                size="small"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() => { checkField() }}
                color="primary"
                variant="contained"
                style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
              >
                <Typography>{t('label.editGoal')}</Typography>
              </Button>
            </Grid>
          </Grid>
          <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title="Discard Change?" text="You’ll lose all filled informantion. We can’t recover them once you changed. Are you sure you want to discard changes made on this page ?" />
        </Container>
      </Box>
    </>
  );
};
export default MyGoalEditForm;
